import LiveVideoPlayer from './LiveVideoPlayer'

export default LiveVideoPlayer
// eslint-disable-next-line import/export
export * from './LiveVideoPlayer'
